
    import { mapActions } from 'vuex';
    import has from 'lodash/has';
    import Cookie from 'js-cookie';

    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faCloudUpload as farCloudUpload,
    } from '@fortawesome/pro-regular-svg-icons/faCloudUpload';

    export default {
        name: 'C1Upload',

        components: {
            FontAwesomeIcon,
        },

        props: {
            title: {
                type: String,
                default: 'Upload a document',
            },

            description: {
                type: String,
                default: 'doc, docx, pdf, jpg, png, gif',
            },

            options: {
                type: Object,
                default: () => { return {}; },
            },

            hideUploadButton: {
                type: Boolean,
                default: false,
            },

            hideDescription: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                dropzone: '',
                isDestroying: false,
                icons: {
                    farCloudUpload,
                },
            };
        },

        computed: {
            isMultiple() {
                return has(this.dropzone, 'options.uploadMultiple') ? this.dropzone.options.uploadMultiple : false;
            },
        },

        mounted() {
            const dropzoneScript = document.createElement('script');
            dropzoneScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.3/min/dropzone.min.js');
            document.head.appendChild(dropzoneScript);
            dropzoneScript.onload = () => {
                this.$nextTick(() => {
                    this.initDropzone();
                });
            };
        },

        beforeDestroy() {
            this.isDestroying = true;
            this.dropzone.destroy();
        },

        methods: {
            ...mapActions('me', {
                $_deleteFile: 'deleteFile',
            }),

            initDropzone() {
                const vm = this;
                window.Dropzone.autoDiscover = false;
                this.dropzone = new window.Dropzone(this.$refs.dropzone, {
                    url: `${process.env.API_URL}/v1/me/upload-files`,
                    maxFiles: 1,
                    addRemoveLinks: false,
                    uploadMultiple: false,
                    maxFilesize: 10,
                    autoProcessQueue: true,
                    previewsContainer: vm.$el.querySelector('.c1-upload__preview'),
                    // acceptedFiles: '.pdf,.doc,.docx,.rtf,.txt',
                    createImageThumbnails: false,
                    headers: {
                        Authorization: `Bearer ${Cookie.get(process.env.COOKIE_TOKEN_NAME)}`,
                    },
                    success(file, response) {
                        const f = response.body.file;
                        vm.$emit('file', f);
                        file.uuid = f.uuid;

                        if (file.previewElement) {
                            return file.previewElement.classList.add('dz-success');
                        }
                    },
                    removedfile(file) {
                        if (vm.isDestroying) {
                            return;
                        }

                        if (file.uuid) {
                            vm.$_deleteFile(file.uuid);
                            vm.$emit('remove', file.uuid);
                        }

                        if (file.previewElement != null && file.previewElement.parentNode != null) {
                            file.previewElement.parentNode.removeChild(file.previewElement);
                        }

                        return this._updateMaxFilesReachedClass();
                    },
                    previewTemplate: vm.dzTemplate(),
                    ...this.options,
                });
            },

            dzClick() {
                this.dropzone.hiddenFileInput.click();
            },

            dzTemplate() {
                return `
                <div class="c1-upload__file">
                    <div class="c1-upload__file__details">
                        <div>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-check-circle fa-w-16" data-v-74952cac=""><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" data-v-74952cac="" class=""></path></svg>
                            <svg data-v-7afb38aa="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-times-circle fa-w-16"><path data-v-7afb38aa="" fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" class=""></path></svg>

                            <span data-dz-name></span>
                        </div>

                        <a href="" data-dz-remove>
                            <svg data-v-7afb38aa="" aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline&#45;&#45;fa fa-trash-alt fa-w-14"><path data-v-7afb38aa="" fill="currentColor" d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z" class=""></path></svg>
                        </a>
                    </div>

                    <div class="c1-upload__file__progress">
                        <span data-dz-uploadprogress></span>
                    </div>

                    <div class="c1-upload__file__error">
                        <span data-dz-errormessage></span>
                    </div>
                </div>
                `;
            },
        },
    };
